import React, { useCallback, useEffect, useState } from "react";
import AdminAppBar from "../../adminComponents/AdminAppBar";
import { FiEdit } from "react-icons/fi";
import Label from "../../Form/Label";
import Heading from "../../Form/Heading";
import { MdOutlineSettings } from "react-icons/md";
import { useLocation, useNavigate } from "react-router-dom";
import GLPagesService from "../../Services/GLPagesService";
import SpinWheelService from "../../Services/SpinWheelService";
import GLpageTemplatePopup from "./GLpageTemplatePopup";
import { ToastContainer } from "react-toastify";
import {
  showErrorToast,
  showInfoToast,
  showSuccessToast,
} from "../../Constant/Notification";
import Select from "react-select";
import AmenitiesService from "../../Services/AmenitiesService";

const GLpageCreatingSection = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { GLPageId } = location.state || {};
  const [openPopup, setOpenPopup] = useState(false);

  const [videoWarning, setVideoWarning] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [showPreview, setShowPreview] = useState(false);
  const [loadingState, setLoadingState] = useState({
    logo: false,
    bannerImages: false,
    section1: false,
    section2: false,
    section3: false,
    section4: false,
    section5: false,
    sectionForm: false,
    sectionMore: false,
  });

  const [basicAmenities, setBasicAmenities] = useState([]);
  const [selectedBasic, setSelectedBasic] = useState([]);
  const [featuresAmenities, setFeaturesAmenities] = useState([]);
  const [selectedFeatures, setSelectedFeatures] = useState([]);
  const [nearbyAmenities, setNearbyAmenities] = useState([]);
  const [selectedNearby, setSelectedNearby] = useState([]);

  const {
    selectedStyleDetails,
    selectedProperty,
    selectedPropertyId,
    selectedPropertyTypeId,
    selectedPropertyTypeName,
  } = location.state || {};


  const {
    isEditMode ,
  } = location.state || {};

  const [formData, setFormData] = useState({
    pageStyle: {
      label: selectedStyleDetails?.label || "",
      color: selectedStyleDetails?.color || "",
    },
    propertyName: selectedProperty || "",
    propertyId: selectedPropertyId || "",
    propertyType: selectedPropertyTypeId || "",
    propertyTypeName: selectedPropertyTypeName || "",
    header: { phoneNumber: "", logo: null },
    hero: {
      bannerImages: [],
      title: "",
      description: "",
    },
    featuresSection: {
      enable: false,
      title: "",
      section1: { image: "", title: "" },
      section2: { image: "", title: "" },
      section3: { image: "", title: "" },
      section4: { image: "", title: "" },
      section5: { image: "", title: "" },
    },
    formData: {
      enable: false,
      image: "",
      title: "",
      description: "",
      field1: { name: "", enable: false },
      field2: { name: "", enable: false },
      field3: { name: "", enable: false },
      field4: { name: "", enable: false },
    },
    gallery: {
      enable: false,
      title: "",
      images: [],
    },
    contactUs: {
      enable: false,
      title: "",
      map: {
        location: "",
        coordinates: { lat: "", lng: "" },
        address: "",
        email: "",
        phoneNumber: "",
      },
    },
    customerTestimonial: {
      enable: false,
      title: "",
      customer1: { name: "", feedback: "" },
      customer2: { name: "", feedback: "" },
      customer3: { name: "", feedback: "" },
    },
    videoSection: {
      enable: false,
      title: "",
      description: "",
      videoLink: "",
    },
    footer: {
      description: "",
    },
    propertyOverview: {
      enable: false,
      name: selectedProperty || "",
      description: "",
      overallArea: 0,
      availableUnits: 0,
      averagePrice: { min: 0, max: 0 },
      averageUnitSqft: { min: 0, max: 0 },
      launchDate: "",
      constructionType: "",
      configuration: "",
      possessionStatus: "",
      basicAmenities: [],
      featuredAmenities: [],
      nearbyAmenities: [],
    },
  });

  const imageSizeGuide = {
    "Luxurious and Rich": {
      logo: "150 x 60px",
      heroBannerSize: "430 x 820px",
      featuresSectionImage: "440 x 490px",
      formImage: "1440 x 620px",
      moreImages: "560 x 300px",
    },
    "Urban and Modern": {
      logo: "150 x 60px",
      heroBannerSize: "1360 x 700px",
      featuresSectionImage: "440 x 260px",
      formImage: "670 x 600px",
      moreImages: "490 x 220px",
    },
  };

  const selectedLabel = selectedStyleDetails?.label || formData.pageStyle.label;
  const sizeGuide = imageSizeGuide[selectedLabel];

  const formatDateForInput = (dateString) => {
    if (!dateString) return "";
    const [month, day, year] = dateString.split("/");
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  };

  const addSelectAllOption = (options) => {
    return [
      { value: "all", label: "Select All" },
      ...options.filter((option) => option.value !== "all"),
    ];
  };

  const handleSelectChange = (selected, type) => {
    const allOptions =
      type === "basic"
        ? basicAmenities
        : type === "features"
        ? featuresAmenities
        : nearbyAmenities;

    const isSelectAll = selected?.some((s) => s.value === "all");
    let newSelectedOptions = [];

    if (isSelectAll) {
      newSelectedOptions = allOptions.filter(
        (option) => option.value !== "all"
      );
    } else {
      newSelectedOptions = (selected || []).filter(
        (option) => option.value !== "all"
      );
    }

    if (type === "basic") {
      setSelectedBasic(newSelectedOptions);
      setFormData({
        ...formData,
        propertyOverview: {
          ...formData.propertyOverview,
          basicAmenities: newSelectedOptions.map((option) => ({
            id: option.value,
            name: option.label,
          })),
        },
      });
    } else if (type === "features") {
      setSelectedFeatures(newSelectedOptions);
      setFormData({
        ...formData,
        propertyOverview: {
          ...formData.propertyOverview,
          featuredAmenities: newSelectedOptions.map((option) => ({
            id: option.value,
            name: option.label,
          })),
        },
      });
    } else {
      setSelectedNearby(newSelectedOptions);
      setFormData({
        ...formData,
        propertyOverview: {
          ...formData.propertyOverview,
          nearbyAmenities: newSelectedOptions.map((option) => ({
            id: option.value,
            name: option.label,
          })),
        },
      });
    }
  };

  const getPropertyOverViewDetails = async () => {
    if (!selectedPropertyId || !selectedPropertyTypeName) return;
    try {
      const response = await GLPagesService.getPropertyOverViewData(
        selectedPropertyId,
        selectedPropertyTypeName
      );
      if (!response.data) {
        showErrorToast("No property overview data found.");
        return;
      }

      const data = response.data;
      console.log("Property overview:", data);

      const basicAmenitiesMapped =
        data.amenities?.[0]?.basicAmenities?.map((item) => ({
          value: item.id,
          label: item.name,
        })) || [];
      const featuredAmenitiesMapped =
        data.amenities?.[0]?.futureAmenities?.map((item) => ({
          value: item.id,
          label: item.name,
        })) || [];
      const nearbyAmenitiesMapped =
        data.amenities?.[0]?.nearByAmenities?.map((item) => ({
          value: item.id,
          label: item.name,
        })) || [];

      setFormData((prev) => ({
        ...prev,
        propertyName: data.propertyName || prev.propertyName,
        propertyOverview: {
          ...prev.propertyOverview,
          name: data.propertyName || prev.propertyOverview.name,
          overallArea: data.overAllSqft || 0,
          availableUnits: data.availableUnitsCount || 0,
          launchDate: formatDateForInput(data.launchDate) || "",
          constructionType: data?.constructionType || "",
          averagePrice: {
            min: data.minAvailableBudget || 0,
            max: data.maxAvailableBudget || 0,
          },
          averageUnitSqft: {
            min: data.minAvailableSqft || 0,
            max: data.maxAvailableSqft || 0,
          },
          configuration: data.configuration || "",
          possessionStatus: data.possessionStatus || "",
          basicAmenities:
            data.amenities?.[0]?.basicAmenities?.map((item) => ({
              id: item.id,
              name: item.name,
            })) || [],
          featuredAmenities:
            data.amenities?.[0]?.futureAmenities?.map((item) => ({
              id: item.id,
              name: item.name,
            })) || [],
          nearbyAmenities:
            data.amenities?.[0]?.nearByAmenities?.map((item) => ({
              id: item.id,
              name: item.name,
            })) || [],
        },
      }));

      setSelectedBasic(basicAmenitiesMapped);
      setSelectedFeatures(featuredAmenitiesMapped);
      setSelectedNearby(nearbyAmenitiesMapped);
    } catch (error) {
      console.error("Error fetching property overview:", error);
      showErrorToast("Failed to fetch property overview data.");
    }
  };

  useEffect(() => {
    if(!isEditMode)
    {
      if (selectedPropertyId && selectedPropertyTypeName) {
        getPropertyOverViewDetails();
      }
    }
    
  }, [selectedPropertyId, selectedPropertyTypeName]);

  useEffect(() => {
    const fetchAmenities = async () => {
      try {
        const response = await AmenitiesService.getAmentities();
        const data = response.data || [];

        setBasicAmenities(
          data
            .filter((item) => item.type === 1)
            .map((item) => ({ value: item.id, label: item.name }))
        );
        setFeaturesAmenities(
          data
            .filter((item) => item.type === 2)
            .map((item) => ({ value: item.id, label: item.name }))
        );
        setNearbyAmenities(
          data
            .filter((item) => item.type === 3)
            .map((item) => ({ value: item.id, label: item.name }))
        );
      } catch (error) {
        console.error("Error fetching amenities data:", error);
        showErrorToast("Failed to fetch amenities data.");
      }
    };
    fetchAmenities();
  }, []);

  const handleClosePopup = useCallback(
    ({
      selectedStyleDetails,
      selectedProperty,
      selectedPropertyId,
      selectedPropertyTypeId,
    } = {}) => {
      setFormData((prevState) => ({
        ...prevState,
        pageStyle: {
          label: selectedStyleDetails?.label || prevState.pageStyle.label,
          color: selectedStyleDetails?.color || prevState.pageStyle.color,
        },
        propertyName: selectedProperty || prevState.propertyName,
        propertyId: selectedPropertyId || prevState.propertyId,
        propertyType: selectedPropertyTypeId || prevState.propertyType,
      }));
      setOpenPopup(false);
    },
    []
  );

  const handleSubmit = async () => {
    if (!formData.header?.logo) {
      showErrorToast("Logo is required.");
      return;
    }
    if (!formData.hero?.title) {
      showErrorToast("Hero Title is required.");
      return;
    }
    if (!formData.hero?.description) {
      showErrorToast("Hero Description is required.");
      return;
    }
    if (!formData.hero?.bannerImages?.length) {
      showErrorToast("Hero Banner Images are required.");
      return;
    }
    if (!formData.header?.phoneNumber) {
      showErrorToast("Phone Number is required.");
      return;
    }

    const phoneRegex = /^[0-9]{10}$/;
    if (!phoneRegex.test(formData.header?.phoneNumber)) {
      showErrorToast("Please enter a valid 10-digit phone number.");
      return;
    }
    if (
      formData.contactUs?.map?.phoneNumber &&
      !phoneRegex.test(formData.contactUs?.map?.phoneNumber)
    ) {
      showErrorToast("Please enter a valid 10-digit contact phone number.");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (
      formData.contactUs?.map?.email &&
      !emailRegex.test(formData.contactUs?.map?.email)
    ) {
      showErrorToast("Please enter a valid email address.");
      return;
    }

    const dataToSend = {
      pageStyle: formData.pageStyle,
      propertyId: formData.propertyId,
      propertyType: formData.propertyType,
      header: formData.header,
      hero: formData.hero,
      featuresSection: formData.featuresSection,
      formData: formData.formData,
      gallery: formData.gallery,
      contactUs: formData.contactUs,
      customerTestimonial: formData.customerTestimonial,
      videoSection: formData.videoSection,
      footer: formData.footer,
      propertyOverview: formData.propertyOverview,
    };

    try {
      if (GLPageId) {
        await GLPagesService.UpdateGLPage(GLPageId, dataToSend);
        showSuccessToast("Page updated successfully!");
      } else {
        await GLPagesService.CreateGLPage(dataToSend);
        showSuccessToast("Page created successfully!");
      }
      navigate(-1);
    } catch (error) {
      console.error("Error saving GL page:", error.message);
      showErrorToast(
        error.response?.data?.message || "Failed to save GL page."
      );
    }
  };

  const getGLPageInfoData = async () => {
    if (!GLPageId) return;
    try {
      const response = await GLPagesService.GetGLPageInfo(GLPageId);
      const data = response.data;

      console.log("GL page info:", response?.property);
      setFormData((prev) => ({
        ...prev,
        ...data,
        propertyName: response?.property?.name || prev.propertyName,
        propertyId: response?.property?.id || prev.propertyId,
        propertyType: response.propertyType || prev.propertyType,
        propertyOverview: {
          ...prev.propertyOverview,
          ...data.propertyOverview,
          name: data.propertyOverview?.name || prev.propertyOverview.name,
        },
      }));
      if (data.propertyOverview) {
        setSelectedBasic(
          data.propertyOverview.basicAmenities?.map((item) => ({
            value: item.id,
            label: item.name,
          })) || []
        );
        setSelectedFeatures(
          data.propertyOverview.featuredAmenities?.map((item) => ({
            value: item.id,
            label: item.name,
          })) || []
        );
        setSelectedNearby(
          data.propertyOverview.nearbyAmenities?.map((item) => ({
            value: item.id,
            label: item.name,
          })) || []
        );
      }
    } catch (error) {
      console.error("Error getting GL Page Info:", error.message);
      showErrorToast(
        error.response?.data?.message || "Failed to fetch GL page info."
      );
    }
  };

  useEffect(() => {
    if (GLPageId) {
      getGLPageInfoData();
    }
  }, [GLPageId]);

  const handleImageChange = async (e, type) => {
    const file = e.target.files[0];
    if (!file) return;

    const allowedTypes = [
      "image/png",
      "image/svg+xml",
      "image/webp",
      "image/jpeg",
      "image/jpg",
    ];
    if (!allowedTypes.includes(file.type)) {
      showErrorToast("Only PNG, SVG, WebP, JPG or JPEG images are allowed.");
      e.target.value = null;
      return;
    }

    if (file.size > 1024 * 1024) {
      showInfoToast("Image size must be less than 1MB.");
      e.target.value = null;
      return;
    }

    if (!sizeGuide) {
      showInfoToast("Please select a valid style template first.");
      return;
    }

    const sizeText =
      type === "logo"
        ? sizeGuide.logo
        : type === "bannerImages"
        ? sizeGuide.heroBannerSize
        : type === "sectionForm"
        ? sizeGuide.formImage
        : type === "sectionMore"
        ? sizeGuide.moreImages
        : sizeGuide.featuresSectionImage;

    const [requiredWidth, requiredHeight] = sizeText
      .split("x")
      .map((n) => parseInt(n.trim()));

    const img = new Image();
    const objectUrl = URL.createObjectURL(file);
    img.src = objectUrl;

    img.onload = async () => {
      const { width, height } = img;
      URL.revokeObjectURL(objectUrl);

      const tolerance = 20;
      const isWidthInRange =
        width >= requiredWidth - tolerance &&
        width <= requiredWidth + tolerance;
      const isHeightInRange =
        height >= requiredHeight - tolerance &&
        height <= requiredHeight + tolerance;

      if (!isWidthInRange || !isHeightInRange) {
        showInfoToast(
          `Please upload an image close to ${requiredWidth}x${requiredHeight}px for "${type}" (${selectedLabel}). Allowed tolerance is ±${tolerance}px.`
        );
        e.target.value = null;
     
      }

      setLoadingState((prev) => ({ ...prev, [type]: true }));

      try {
        const uploadFormData = new FormData();
        uploadFormData.append("file", file);
        const folderPath = "GLpage";
        const response = await SpinWheelService.createBannerImageTemplate(
          uploadFormData,
          folderPath
        );

        setFormData((prev) => {
          if (type === "logo") {
            return {
              ...prev,
              header: { ...prev.header, logo: response.data.imageUrl },
            };
          } else if (
            [
              "section1",
              "section2",
              "section3",
              "section4",
              "section5",
            ].includes(type)
          ) {
            return {
              ...prev,
              featuresSection: {
                ...prev.featuresSection,
                [type]: {
                  ...prev.featuresSection[type],
                  image: response.data.imageUrl,
                },
              },
            };
          } else if (type === "bannerImages") {
            return {
              ...prev,
              hero: {
                ...prev.hero,
                bannerImages: [
                  ...prev.hero.bannerImages,
                  response.data.imageUrl,
                ],
              },
            };
          } else if (type === "sectionMore") {
            return {
              ...prev,
              gallery: {
                ...prev.gallery,
                images: [...prev.gallery.images, response.data.imageUrl],
              },
            };
          } else if (type === "sectionForm") {
            return {
              ...prev,
              formData: {
                ...prev.formData,
                image: response.data.imageUrl,
              },
            };
          }
          return prev;
        });
      } catch (error) {
        console.error("Error uploading image:", error.response?.data);
        showErrorToast("Failed to upload image.");
      } finally {
        setLoadingState((prev) => ({ ...prev, [type]: false }));
      }
    };
  };

  const handelDeleteImages = async (imageUrl, type) => {
    try {
      await GLPagesService.DeleteGLPageImage(imageUrl);
      setFormData((prev) => {
        if (type === "logo") {
          return { ...prev, header: { ...prev.header, logo: null } };
        } else if (type === "bannerImages") {
          return {
            ...prev,
            hero: {
              ...prev.hero,
              bannerImages: prev.hero.bannerImages.filter(
                (img) => img !== imageUrl
              ),
            },
          };
        } else if (type === "sectionMore") {
          return {
            ...prev,
            gallery: {
              ...prev.gallery,
              images: prev.gallery.images.filter((img) => img !== imageUrl),
            },
          };
        } else if (
          ["section1", "section2", "section3", "section4", "section5"].includes(
            type
          )
        ) {
          return {
            ...prev,
            featuresSection: {
              ...prev.featuresSection,
              [type]: { ...prev.featuresSection[type], image: null },
            },
          };
        } else if (type === "sectionForm") {
          return {
            ...prev,
            formData: { ...prev.formData, image: null },
          };
        }
        return prev;
      });
    } catch (error) {
      console.error(
        "Error deleting image:",
        error.response?.data || error.message
      );
      showErrorToast("Failed to delete image.");
    }
  };

  const handlePreviewClick = () => {
    setShowPreview(!showPreview);
  };

  const handelBack = () => {
    navigate(-1);
  };

  return (
    <div className="bg-appGrayBackground min-h-screen pt-20">
      <ToastContainer />
       <AdminAppBar />
      <div className="px-14">
        <div className="flex flex-col">
          <div className="flex justify-between items-center">
            <div className="flex items-center gap-3">
              <svg
                onClick={handelBack}
                className="cursor-pointer"
                width="16"
                height="28"
                viewBox="0 0 22 38"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.23223 17.2322C0.255922 18.2085 0.255922 19.7915 1.23223 20.7678L17.1421 36.6777C18.1184 37.654 19.7014 37.654 20.6777 36.6777C21.654 35.7014 21.654 34.1184 20.6777 33.1421L6.53553 19L20.6777 4.85786C21.654 3.88155 21.654 2.29864 20.6777 1.32233C19.7014 0.34602 18.1184 0.34602 17.1421 1.32233L1.23223 17.2322ZM5 16.5L3 16.5L3 21.5L5 21.5L5 16.5Z"
                  fill="#399E79"
                />
              </svg>
              <h1 className="text-3xl font-bold">
                {GLPageId ? "Edit" : "New"} GL Page
              </h1>
            </div>
            <div className="flex gap-3">
              {GLPageId && (
                <button
                  onClick={handlePreviewClick}
                  className="mt-6 w-36 bg-emerald-600 cursor-pointer text-white py-2 rounded"
                >
                  {showPreview ? "Hide Preview" : "Show Preview"}
                </button>
              )}
              <button
                onClick={handleSubmit}
                className="mt-6 w-36 bg-emerald-600 cursor-pointer text-white py-2 rounded"
              >
                {GLPageId ? "Update" : "Create"}
              </button>
            </div>
          </div>
          {showPreview && (
            <div className="mt-6">
              <iframe
                src={`http://crm.glpages.s3-website.ap-south-1.amazonaws.com/gl-page/${GLPageId}`}
                width="100%"
                height="600px"
                title="Preview"
                frameBorder="0"
              />
            </div>
          )}
          <div className="flex p-3 bg-white max-w-fit gap-4 items-center rounded-lg">
            <div className="flex items-center text-nowrap gap-2">
              <div>Property:</div>
              <div className="text-xl font-bold">{formData.propertyName}</div>
            </div>
            <div className="flex items-center gap-2 text-nowrap">
              <div>Page Style:</div>
              <div className={`text-xl font-bold ${formData.pageStyle.color}`}>
                {formData.pageStyle.label}
              </div>
              <FiEdit
                onClick={() => setOpenPopup(true)}
                className="cursor-pointer text-lg hover:text-emerald-600"
              />
            </div>
          </div>
        </div>
        <div className="bg-white rounded-md p-6 mt-5">
          <Heading text="Header" Icon={MdOutlineSettings} />
          <div className="px-10 pt-6 pb-16">
            <div className="flex flex-col gap-3">
              <div className="flex justify-between gap-2">
                <div className="flex gap-2">
                  <span className="w-1 h-5 bg-red-400 rounded-sm"></span>
                  <Label label={"Header Logo"} />
                </div>
                <div className="flex flex-col items-center justify-center w-[75%]">
                  <label
                    htmlFor="header-logo-file"
                    className="flex flex-col items-center justify-center w-full h-40 border-2 border-customGreen border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100"
                  >
                    <div className="flex flex-col items-center justify-center pt-5 pb-6">
                      <svg
                        className="w-8 h-8 mb-4 text-customGreen"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 20 16"
                      >
                        <path
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                        />
                      </svg>
                      <p className="mb-2 text-sm text-gray-500">
                        <span className="font-semibold">Click to upload</span>{" "}
                        or drag and drop
                      </p>
                      <p className="text-xs text-gray-500">
                        PNG, SVG, WebP, JPG or JPEG and Recommended size:{" "}
                        {sizeGuide?.logo || "Max 800x400px"}
                      </p>
                    </div>
                    <input
                      id="header-logo-file"
                      type="file"
                      className="hidden"
                      disabled={loadingState.logo || formData.header.logo}
                      onChange={(e) => handleImageChange(e, "logo")}
                    />
                  </label>
                  {loadingState.logo && (
                    <div className="loading-container flex flex-col items-center mt-4">
                      <div className="spinner"></div>
                      <p className="text-sm text-gray-600 mt-2">
                        Uploading image, please wait...
                      </p>
                    </div>
                  )}
                  {formData.header.logo && !loadingState.logo && (
                    <div className="mt-4 relative">
                      <img
                        src={formData.header.logo}
                        alt="Header Logo"
                        className="w-16 h-16 rounded-lg shadow-md border border-gray-200"
                      />
                      <button
                        className="absolute top-0 right-0 text-red-500 bg-white rounded-full p-1 shadow-md"
                        onClick={() =>
                          handelDeleteImages(formData.header.logo, "logo")
                        }
                      >
                        X
                      </button>
                    </div>
                  )}
                </div>
              </div>
              <div className="flex justify-between gap-2">
                <div className="flex gap-2">
                  <span className="w-1 h-5 bg-red-400 rounded-sm"></span>
                  <Label label={"Display Phone Number"} />
                </div>
                <div className="flex items-center justify-center w-[75%]">
                  <input
                    type="text"
                    placeholder="Enter number"
                    value={formData.header.phoneNumber}
                    onChange={(e) => {
                      const input = e.target.value;
                      // Allow only digits (0-9)
                      if (/^\d*$/.test(input)) {
                        setFormData({
                          ...formData,
                          header: { ...formData.header, phoneNumber: input },
                        });
                      }
                    }}
                    maxLength={10}
                    className="w-full px-4 py-2 bg-slate-100 border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none"
                  />
                </div>
              </div>
            </div>
          </div>
          <Heading text="Hero slider" Icon={MdOutlineSettings} />
          <div className="px-10 pt-6">
            <div className="flex flex-col gap-3">
              <div className="flex justify-between gap-2">
                <div className="flex gap-2">
                  <span className="w-1 h-5 bg-red-400 rounded-sm"></span>
                  <Label label={"Slider Image"} />
                </div>
                <div className="flex flex-col items-center justify-center w-[75%]">
                  <label
                    htmlFor="hero-banner-file"
                    className="flex flex-col items-center justify-center w-full h-40 border-2 border-customGreen border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100"
                  >
                    <div className="flex flex-col items-center justify-center pt-5 pb-6">
                      <svg
                        className="w-8 h-8 mb-4 text-customGreen"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 20 16"
                      >
                        <path
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                        />
                      </svg>
                      <p className="mb-2 text-sm text-gray-500">
                        <span className="font-semibold">Click to upload</span>{" "}
                        or drag and drop
                      </p>
                      <p className="text-xs text-gray-500">
                        PNG, SVG, WebP, JPG or JPEG and Recommended size:{" "}
                        {sizeGuide?.heroBannerSize || "Max 800x400px"}
                      </p>
                    </div>
                    <input
                      id="hero-banner-file"
                      type="file"
                      className="hidden"
                      onChange={(e) => handleImageChange(e, "bannerImages")}
                    />
                  </label>
                  {loadingState.bannerImages && (
                    <div className="loading-container flex flex-col items-center mt-4">
                      <div className="spinner"></div>
                      <p className="text-sm text-gray-600 mt-2">
                        Uploading image, please wait...
                      </p>
                    </div>
                  )}
                  {formData.hero.bannerImages.length > 0 &&
                    !loadingState.bannerImages && (
                      <div className="mt-4 flex gap-2 relative">
                        {formData.hero.bannerImages.map((image, index) => (
                          <div key={index} className="relative">
                            <img
                              src={image}
                              alt={`Banner Preview ${index + 1}`}
                              className="w-16 h-16 rounded-lg shadow-md"
                            />
                            <button
                              className="absolute top-0 right-0 text-red-500 bg-white rounded-full p-1 shadow-md"
                              onClick={() =>
                                handelDeleteImages(image, "bannerImages")
                              }
                            >
                              X
                            </button>
                          </div>
                        ))}
                      </div>
                    )}
                </div>
              </div>
              <div className="flex justify-between gap-2">
                <div className="flex gap-2">
                  <span className="w-1 h-5 bg-red-400 rounded-sm"></span>
                  <Label label={"Slider Title"} />
                </div>
                <div className="flex items-center justify-center w-[75%]">
                  <input
                    type="text"
                    placeholder="Enter Title"
                    value={formData.hero.title}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        hero: { ...formData.hero, title: e.target.value },
                      })
                    }
                    maxLength={50}
                    className="w-full px-4 py-2 bg-slate-100 border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none"
                  />
                </div>
              </div>
              <div className="flex justify-between gap-2">
                <div className="flex gap-2">
                  <span className="w-1 h-5 bg-red-400 rounded-sm"></span>
                  <Label label={"Slider Description"} />
                </div>
                <div className="flex items-center justify-center w-[75%]">
                  <textarea
                    placeholder="Enter Description"
                    value={formData.hero.description}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        hero: { ...formData.hero, description: e.target.value },
                      })
                    }
                    maxLength={90}
                    className="w-full h-24 px-4 py-2 bg-slate-100 border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none"
                  />
                </div>
              </div>
            </div>
          </div>
          <Heading text="Features Section" Icon={MdOutlineSettings} />
          <div className="px-10 pt-6 pb-16">
            <div className="flex flex-col gap-3">
              <div className="flex justify-between gap-2">
                <Label label={"Enable This Section"} />
                <div className="flex w-[75%]">
                  <label className="inline-flex mb-5 cursor-pointer">
                    <input
                      type="checkbox"
                      checked={formData.featuresSection.enable}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          featuresSection: {
                            ...formData.featuresSection,
                            enable: e.target.checked,
                          },
                        })
                      }
                      className="sr-only peer"
                    />
                    <div className="relative w-9 h-5 bg-red-500 rounded-full peer-checked:bg-emerald-600 after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:after:translate-x-full" />
                  </label>
                </div>
              </div>
              <div className="flex justify-between gap-2">
                <Label label={"Section Title"} />
                <div className="flex items-center justify-center w-[75%]">
                  <input
                    type="text"
                    value={formData.featuresSection.title}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        featuresSection: {
                          ...formData.featuresSection,
                          title: e.target.value,
                        },
                      })
                    }
                    maxLength={50}
                    placeholder="Enter section title"
                    className="w-full px-4 py-2 bg-slate-100 border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none"
                  />
                </div>
              </div>
              {[1, 2, 3, 4, 5].map((num) => (
                <div key={`feature${num}`}>
                  <div className="flex justify-between gap-2">
                    <Label label={`Feature ${num} Title`} />
                    <div className="flex items-center justify-center w-[75%]">
                      <input
                        type="text"
                        value={formData.featuresSection[`section${num}`].title}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            featuresSection: {
                              ...formData.featuresSection,
                              [`section${num}`]: {
                                ...formData.featuresSection[`section${num}`],
                                title: e.target.value,
                              },
                            },
                          })
                        }
                        maxLength={50}
                        placeholder={`Enter section title ${num}`}
                        className="w-full px-4 py-2 bg-slate-100 border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none"
                      />
                    </div>
                  </div>
                  <div className="flex justify-between gap-2 mt-4">
                    <Label label={`Feature ${num} Image`} />
                    <div className="flex flex-col items-center justify-center w-[75%]">
                      <label
                        htmlFor={`Feature${num}`}
                        className="flex flex-col items-center justify-center w-full h-40 border-2 border-customGreen border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100"
                      >
                        <div className="flex flex-col items-center justify-center pt-5 pb-6">
                          <svg
                            className="w-8 h-8 mb-4 text-customGreen"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 20 16"
                          >
                            <path
                              stroke="currentColor"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                            />
                          </svg>
                          <p className="mb-2 text-sm text-gray-500">
                            <span className="font-semibold">
                              Click to upload
                            </span>{" "}
                            or drag and drop
                          </p>
                          <p className="text-xs text-gray-500">
                            PNG, SVG, WebP, JPG or JPEG and Recommended size:{" "}
                            {sizeGuide?.featuresSectionImage || "Max 800x400px"}
                          </p>
                        </div>
                        <input
                          id={`Feature${num}`}
                          type="file"
                          className="hidden"
                          disabled={
                            loadingState[`section${num}`] ||
                            formData.featuresSection[`section${num}`].image
                          }
                          onChange={(e) =>
                            handleImageChange(e, `section${num}`)
                          }
                        />
                      </label>
                      {loadingState[`section${num}`] && (
                        <div className="loading-container flex flex-col items-center mt-4">
                          <div className="spinner"></div>
                          <p className="text-sm text-gray-600 mt-2">
                            Uploading image, please wait...
                          </p>
                        </div>
                      )}
                      {formData.featuresSection[`section${num}`].image &&
                        !loadingState[`section${num}`] && (
                          <div className="relative mt-4">
                            <img
                              src={
                                formData.featuresSection[`section${num}`].image
                              }
                              alt={`Section ${num} Image`}
                              className="w-16 h-16 rounded-lg shadow-md border border-gray-200"
                            />
                            <button
                              className="absolute top-0 right-0 text-red-500 bg-white rounded-full p-1 shadow-md"
                              onClick={() =>
                                handelDeleteImages(
                                  formData.featuresSection[`section${num}`]
                                    .image,
                                  `section${num}`
                                )
                              }
                            >
                              X
                            </button>
                          </div>
                        )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <Heading text="Property Overviews" Icon={MdOutlineSettings} />
          <div className="px-10 pt-6 pb-16">
            <div className="flex flex-col gap-3">
              <div className="flex justify-between gap-2">
                <Label label={"Enable This Section"} />
                <div className="flex w-[75%]">
                  <label className="inline-flex mb-5 cursor-pointer">
                    <input
                      type="checkbox"
                      checked={formData.propertyOverview.enable}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          propertyOverview: {
                            ...formData.propertyOverview,
                            enable: e.target.checked,
                          },
                        })
                      }
                      className="sr-only peer"
                    />
                    <div className="relative w-9 h-5 bg-red-500 rounded-full peer-checked:bg-emerald-600 after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:after:translate-x-full" />
                  </label>
                </div>
              </div>
              <div className="flex justify-between gap-2">
                <Label label={"Property Name"} />
                <div className="flex items-center justify-center w-[75%]">
                  <input
                    aria-label="Property name"
                    value={formData.propertyOverview.name}
                    readOnly
                    className="w-full px-4 py-2 bg-slate-100 border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none"
                  />
                </div>
              </div>
              <div className="flex justify-between gap-2">
                <Label label={"Property Description"} />
                <div className="flex items-center justify-center w-[75%]">
                  <textarea
                    value={formData.propertyOverview.description}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        propertyOverview: {
                          ...formData.propertyOverview,
                          description: e.target.value,
                        },
                      })
                    }
                    maxLength={1000}
                    placeholder="Enter Description"
                    className="w-full px-4 py-2 bg-slate-100 border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none"
                  />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-6 mt-6">
                <div className="flex items-center gap-4">
                  <div className="w-1/2">
                    <Label label={"Overall Area"} />
                  </div>
                  <div className="w-1/2">
                    <input
                      type="text"
                      inputMode="numeric"
                      pattern="[0-9]*"
                      value={
                        formData.propertyOverview.overallArea === 0
                          ? ""
                          : formData.propertyOverview.overallArea
                      }
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value.length <= 10) {
                          setFormData({
                            ...formData,
                            propertyOverview: {
                              ...formData.propertyOverview,
                              overallArea: parseInt(value) || 0,
                            },
                          });
                        }
                      }}
                      placeholder="Enter Area"
                      className="w-full px-4 py-2 bg-slate-100 border border-slate-300 text-gray-700 rounded-md shadow-sm focus:outline-none"
                    />
                  </div>
                </div>
                <div className="flex items-center gap-4">
                  <div className="w-1/2">
                    <Label label={"Average Price"} />
                  </div>
                  <div className="w-[22%]">
                    <input
                      type="text"
                      inputMode="numeric"
                      pattern="[0-9]*"
                      value={
                        formData.propertyOverview.averagePrice.min === 0
                          ? ""
                          : formData.propertyOverview.averagePrice.min
                      }
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value.length <= 10) {
                          setFormData({
                            ...formData,
                            propertyOverview: {
                              ...formData.propertyOverview,
                              averagePrice: {
                                ...formData.propertyOverview.averagePrice,
                                min: parseInt(value) || 0,
                              },
                            },
                          });
                        }
                      }}
                      placeholder="Min Price"
                      className="w-full px-4 py-2 bg-slate-100 border border-slate-300 text-gray-700 rounded-md shadow-sm focus:outline-none"
                    />
                  </div>
                  <div className="w-[25%]">
                    <input
                      type="text"
                      inputMode="numeric"
                      pattern="[0-9]*"
                      value={
                        formData.propertyOverview.averagePrice.max === 0
                          ? ""
                          : formData.propertyOverview.averagePrice.max
                      }
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value.length <= 10) {
                          setFormData({
                            ...formData,
                            propertyOverview: {
                              ...formData.propertyOverview,
                              averagePrice: {
                                ...formData.propertyOverview.averagePrice,
                                max: parseInt(value) || 0,
                              },
                            },
                          });
                        }
                      }}
                      placeholder="Max Price"
                      className="w-full px-4 py-2 bg-slate-100 border border-slate-300 text-gray-700 rounded-md shadow-sm focus:outline-none"
                    />
                  </div>
                </div>
                <div className="flex items-center gap-4">
                  <div className="w-1/2">
                    <Label label={"Average Unit SQ.FT"} />
                  </div>
                  <div className="w-[25%]">
                    <input
                      type="text"
                      inputMode="numeric"
                      pattern="[0-9]*"
                      value={
                        formData.propertyOverview.averageUnitSqft.min === 0
                          ? ""
                          : formData.propertyOverview.averageUnitSqft.min
                      }
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value.length <= 10) {
                          setFormData({
                            ...formData,
                            propertyOverview: {
                              ...formData.propertyOverview,
                              averageUnitSqft: {
                                ...formData.propertyOverview.averageUnitSqft,
                                min: parseInt(value) || 0,
                              },
                            },
                          });
                        }
                      }}
                      placeholder="Min Unit SQ.FT"
                      className="w-full px-4 py-2 bg-slate-100 border border-slate-300 text-gray-700 rounded-md shadow-sm focus:outline-none"
                    />
                  </div>
                  <div className="w-[22%]">
                    <input
                      type="number"
                      value={
                        formData.propertyOverview.averageUnitSqft.max === 0
                          ? ""
                          : formData.propertyOverview.averageUnitSqft.max
                      }
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value.length <= 10) {
                          setFormData({
                            ...formData,
                            propertyOverview: {
                              ...formData.propertyOverview,
                              averageUnitSqft: {
                                ...formData.propertyOverview.averageUnitSqft,
                                max: parseInt(value) || 0,
                              },
                            },
                          });
                        }
                      }}
                      placeholder="Max Unit SQ.FT"
                      className="w-full px-4 py-2 bg-slate-100 border border-slate-300 text-gray-700 rounded-md shadow-sm focus:outline-none"
                    />
                  </div>
                </div>
                <div className="flex items-center gap-4">
                  <div className="w-1/2">
                    <Label label={"Available Units"} />
                  </div>
                  <div className="w-1/2">
                    <input
                      type="text"
                      inputMode="numeric"
                      pattern="[0-9]*"
                      value={
                        formData.propertyOverview.availableUnits === 0
                          ? ""
                          : formData.propertyOverview.availableUnits
                      }
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value.length <= 10) {
                          setFormData({
                            ...formData,
                            propertyOverview: {
                              ...formData.propertyOverview,
                              availableUnits: parseInt(value) || 0,
                            },
                          });
                        }
                      }}
                      placeholder="Enter Available Units"
                      className="w-full px-4 py-2 bg-slate-100 border border-slate-300 text-gray-700 rounded-md shadow-sm focus:outline-none"
                    />
                  </div>
                </div>
                <div className="flex items-center gap-4">
                  <div className="w-1/2">
                    <Label label={"Launch Date"} />
                  </div>
                  <div className="w-1/2">
                    <input
                      type="date"
                      value={formData.propertyOverview.launchDate}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          propertyOverview: {
                            ...formData.propertyOverview,
                            launchDate: e.target.value,
                          },
                        })
                      }
                      className="w-full px-4 py-2 bg-slate-100 border border-slate-300 text-gray-700 rounded-md shadow-sm focus:outline-none"
                    />
                  </div>
                </div>
                {formData.propertyTypeName === "Villa" && (
                  <>
                    <div className="flex items-center gap-4">
                      <div className="w-1/2">
                        <Label label={"Configuration (BHK)"} />
                      </div>
                      <div className="w-1/2">
                        <input
                          type="number"
                          value={formData.propertyOverview.configuration}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              propertyOverview: {
                                ...formData.propertyOverview,
                                configuration: e.target.value,
                              },
                            })
                          }
                          placeholder="Enter Configuration (BHK)"
                          className="w-full px-4 py-2 bg-slate-100 border border-slate-300 text-gray-700 rounded-md shadow-sm focus:outline-none"
                        />
                      </div>
                    </div>
                    <div className="flex items-center gap-4">
                      <div className="w-1/2">
                        <Label label={"Possession Status"} />
                      </div>
                      <div className="w-1/2">
                        <select
                          value={formData.propertyOverview.constructionType}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              propertyOverview: {
                                ...formData.propertyOverview,
                                constructionType: e.target.value,
                              },
                            })
                          }
                          className="w-full px-4 py-2 bg-slate-100 border border-slate-300 text-gray-700 rounded-md shadow-sm focus:outline-none"
                        >
                          <option value="">Select Status</option>
                          <option value="Ready to Move">Ready to Move</option>
                          <option value="Under Construction">
                            Under Construction
                          </option>
                          <option value="Upcoming">Upcoming</option>
                        </select>
                      </div>
                    </div>
                  </>
                )}
              </div>
              <Label label={"Amenities"} className="mt-6" />
              <div className="my-4 flex items-center justify-between gap-4">
                <div className="w-[25%]">
                  <Label label="Basic Amenities" />
                </div>
                <div className="w-[78%]">
                  <Select
                    isMulti
                    options={addSelectAllOption(basicAmenities)}
                    value={selectedBasic}
                    onChange={(e) => handleSelectChange(e, "basic")}
                    className="w-full"
                    placeholder="Select Basic Amenities"
                  />
                </div>
              </div>
              <div className="my-4 flex items-center justify-between gap-4">
                <div className="w-[25%]">
                  <Label label="Featured Amenities" />
                </div>
                <div className="w-[78%]">
                  <Select
                    isMulti
                    options={addSelectAllOption(featuresAmenities)}
                    value={selectedFeatures}
                    onChange={(e) => handleSelectChange(e, "features")}
                    className="w-full"
                    placeholder="Select Featured Amenities"
                  />
                </div>
              </div>
              <div className="my-4 flex items-center justify-between gap-4">
                <div className="w-[25%]">
                  <Label label="Nearby Amenities" />
                </div>
                <div className="w-[78%]">
                  <Select
                    isMulti
                    options={addSelectAllOption(nearbyAmenities)}
                    value={selectedNearby}
                    onChange={(e) => handleSelectChange(e, "nearby")}
                    className="w-full"
                    placeholder="Select Nearby Amenities"
                  />
                </div>
              </div>
            </div>
          </div>
          <Heading text="Form" Icon={MdOutlineSettings} />
          <div className="px-10 pt-6 pb-16">
            <div className="flex flex-col gap-3">
              <div className="flex justify-between gap-2">
                <Label label={"Enable This Section"} />
                <div className="flex w-[75%]">
                  <label className="inline-flex mb-5 cursor-pointer">
                    <input
                      type="checkbox"
                      checked={formData.formData.enable}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          formData: {
                            ...formData.formData,
                            enable: e.target.checked,
                          },
                        })
                      }
                      className="sr-only peer"
                    />
                    <div className="relative w-9 h-5 bg-red-500 rounded-full peer-checked:bg-emerald-600 after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:after:translate-x-full" />
                  </label>
                </div>
              </div>
              <div className="flex justify-between gap-2">
                <Label label={"Form Image"} />
                <div className="flex flex-col items-center justify-center w-[75%]">
                  <label
                    htmlFor="FormImage"
                    className="flex flex-col items-center justify-center w-full h-40 border-2 border-customGreen border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100"
                  >
                    <div className="flex flex-col items-center justify-center pt-5 pb-6">
                      <svg
                        className="w-8 h-8 mb-4 text-customGreen"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 20 16"
                      >
                        <path
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                        />
                      </svg>
                      <p className="mb-2 text-sm text-gray-500">
                        <span className="font-semibold">Click to upload</span>{" "}
                        or drag and drop
                      </p>
                      <p className="text-xs text-gray-500">
                        PNG, SVG, WebP, JPG or JPEG and Recommended size:{" "}
                        {sizeGuide?.formImage || "Max 800x400px"}
                      </p>
                    </div>
                    <input
                      id="FormImage"
                      type="file"
                      className="hidden"
                      disabled={
                        loadingState.sectionForm || formData.formData.image
                      }
                      onChange={(e) => handleImageChange(e, "sectionForm")}
                    />
                  </label>
                  {loadingState.sectionForm && (
                    <div className="loading-container flex flex-col items-center mt-4">
                      <div className="spinner"></div>
                      <p className="text-sm text-gray-600 mt-2">
                        Uploading image, please wait...
                      </p>
                    </div>
                  )}
                  {formData.formData.image && !loadingState.sectionForm && (
                    <div className="mt-4 relative">
                      <img
                        src={formData.formData.image}
                        alt="Form Section Image"
                        className="w-16 h-16 rounded-lg shadow-md"
                      />
                      <button
                        className="absolute top-0 right-0 text-red-500 bg-white rounded-full p-1 shadow-md"
                        onClick={() =>
                          handelDeleteImages(
                            formData.formData.image,
                            "sectionForm"
                          )
                        }
                      >
                        X
                      </button>
                    </div>
                  )}
                </div>
              </div>
              <div className="flex justify-between gap-2">
                <Label label={"Section Title"} />
                <div className="flex items-center justify-center w-[75%]">
                  <input
                    type="text"
                    placeholder="Enter Section Title"
                    value={formData.formData.title}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        formData: {
                          ...formData.formData,
                          title: e.target.value,
                        },
                      })
                    }
                    maxLength={50}
                    className="w-full px-4 py-2 bg-slate-100 border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none"
                  />
                </div>
              </div>
              <div className="flex justify-between gap-2">
                <Label label={"Section Description"} />
                <div className="flex items-center justify-center w-[75%]">
                  <textarea
                    value={formData.formData.description}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        formData: {
                          ...formData.formData,
                          description: e.target.value,
                        },
                      })
                    }
                    maxLength={120}
                    placeholder="Enter Description"
                    className="w-full px-4 py-2 bg-slate-100 border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none"
                  />
                </div>
              </div>
              {[1, 2, 3, 4].map((num) => (
                <div className="flex justify-between gap-2" key={`field${num}`}>
                  <Label label={`Field ${num}`} />
                  <div className="flex items-center justify-center w-[75%]">
                    <input
                      type="text"
                      value={formData.formData[`field${num}`].name}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          formData: {
                            ...formData.formData,
                            [`field${num}`]: {
                              ...formData.formData[`field${num}`],
                              name: e.target.value,
                            },
                          },
                        })
                      }
                      maxLength={15}
                      placeholder={`Enter Field ${num}`}
                      className="w-full px-4 py-2 bg-slate-100 border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none"
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
          <Heading text="More Images" Icon={MdOutlineSettings} />
          <div className="px-10 pt-6 pb-16">
            <div className="flex flex-col gap-3">
              <div className="flex justify-between gap-2">
                <Label label={"Enable This Section"} />
                <div className="flex w-[75%]">
                  <label className="inline-flex mb-5 cursor-pointer">
                    <input
                      type="checkbox"
                      checked={formData.gallery.enable}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          gallery: {
                            ...formData.gallery,
                            enable: e.target.checked,
                          },
                        })
                      }
                      className="sr-only peer"
                    />
                    <div className="relative w-9 h-5 bg-red-500 rounded-full peer-checked:bg-emerald-600 after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:after:translate-x-full" />
                  </label>
                </div>
              </div>
              <div className="flex justify-between gap-2">
                <Label label={"Section Title"} />
                <div className="flex items-center justify-center w-[75%]">
                  <input
                    type="text"
                    placeholder="Enter section title"
                    value={formData.gallery.title}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        gallery: { ...formData.gallery, title: e.target.value },
                      })
                    }
                    maxLength={50}
                    className="w-full px-4 py-2 bg-slate-100 border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none"
                  />
                </div>
              </div>
              <div className="flex justify-between gap-2">
                <Label label={"Images"} />
                <div className="flex flex-col items-center justify-center w-[75%]">
                  <label
                    htmlFor="MoreImages"
                    className="flex flex-col items-center justify-center w-full h-40 border-2 border-customGreen border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100"
                  >
                    <div className="flex flex-col items-center justify-center pt-5 pb-6">
                      <svg
                        className="w-8 h-8 mb-4 text-customGreen"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 20 16"
                      >
                        <path
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                        />
                      </svg>
                      <p className="mb-2 text-sm text-gray-500">
                        <span className="font-semibold">Click to upload</span>{" "}
                        or drag and drop
                      </p>
                      <p className="text-xs text-gray-500">
                        PNG, SVG, WebP, JPG or JPEG and Recommended size:{" "}
                        {sizeGuide?.moreImages || "Max 800x400px"}
                      </p>
                    </div>
                    <input
                      id="MoreImages"
                      type="file"
                      className="hidden"
                      disabled={loadingState.sectionMore}
                      onChange={(e) => handleImageChange(e, "sectionMore")}
                    />
                  </label>
                  {loadingState.sectionMore && (
                    <div className="loading-container flex flex-col items-center mt-4">
                      <div className="spinner"></div>
                      <p className="text-sm text-gray-600 mt-2">
                        Uploading image, please wait...
                      </p>
                    </div>
                  )}
                  {formData.gallery.images.length > 0 &&
                    !loadingState.sectionMore && (
                      <div className="mt-4 flex gap-2">
                        {formData.gallery.images.map((image, index) => (
                          <div key={index} className="relative">
                            <img
                              src={image}
                              alt={`Gallery Preview ${index + 1}`}
                              className="w-16 h-16 rounded-lg shadow-md"
                            />
                            <button
                              className="absolute top-0 right-0 text-red-500 bg-white rounded-full p-1 shadow-md"
                              onClick={() =>
                                handelDeleteImages(image, "sectionMore")
                              }
                            >
                              X
                            </button>
                          </div>
                        ))}
                      </div>
                    )}
                </div>
              </div>
            </div>
          </div>
          <Heading text="Contact Us Section" Icon={MdOutlineSettings} />
          <div className="px-10 pt-6 pb-16">
            <div className="flex flex-col gap-3">
              <div className="flex justify-between gap-2">
                <Label label={"Enable This Section"} />
                <div className="flex w-[75%]">
                  <label className="inline-flex mb-5 cursor-pointer">
                    <input
                      type="checkbox"
                      checked={formData.contactUs.enable}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          contactUs: {
                            ...formData.contactUs,
                            enable: e.target.checked,
                          },
                        })
                      }
                      className="sr-only peer"
                    />
                    <div className="relative w-9 h-5 bg-red-500 rounded-full peer-checked:bg-emerald-600 after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:after:translate-x-full" />
                  </label>
                </div>
              </div>
              <div className="flex justify-between gap-2">
                <Label label={"Section Title"} />
                <div className="flex items-center justify-center w-[75%]">
                  <input
                    type="text"
                    value={formData.contactUs.title}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        contactUs: {
                          ...formData.contactUs,
                          title: e.target.value,
                        },
                      })
                    }
                    maxLength={50}
                    placeholder="Enter Title"
                    className="w-full px-4 py-2 bg-slate-100 border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none"
                  />
                </div>
              </div>
              <div className="flex justify-between gap-2">
        <label className="font-semibold w-1/4">Latitude & Longitude</label>
        <div className="flex items-center justify-center gap-4 w-[75%]">

          {/* Latitude Input */}
          <input
            type="text"
            placeholder="Enter Latitude (e.g., 12.3456)"
            value={formData.contactUs.map.coordinates.lat}
            onChange={(e) => {
              const value = e.target.value.trim();
              const cleaned = value.replace(/[^\d.\-]/g, "");
              const parsed = parseFloat(cleaned);

              if (cleaned === "" || (!isNaN(parsed) && parsed >= -90 && parsed <= 90)) {
                setFormData({
                  ...formData,
                  contactUs: {
                    ...formData.contactUs,
                    map: {
                      ...formData.contactUs.map,
                      coordinates: {
                        ...formData.contactUs.map.coordinates,
                        lat: cleaned,
                      },
                    },
                  },
                });
              } else {
                showInfoToast("Latitude must be between -90 and 90");
              }
            }}
            
            className="w-full px-4 py-2 bg-slate-100 border border-slate-300 text-gray-700 rounded-md shadow-sm focus:outline-none"
          />

          {/* Longitude Input */}
          <input
            type="text"
            placeholder="Enter Longitude (e.g., 77.1234)"
            value={formData.contactUs.map.coordinates.lng}
            onChange={(e) => {
              const value = e.target.value.trim();
              const cleaned = value.replace(/[^\d.\-]/g, "");
              const parsed = parseFloat(cleaned);

              if (cleaned === "" || (!isNaN(parsed) && parsed >= -180 && parsed <= 180)) {
                setFormData({
                  ...formData,
                  contactUs: {
                    ...formData.contactUs,
                    map: {
                      ...formData.contactUs.map,
                      coordinates: {
                        ...formData.contactUs.map.coordinates,
                        lng: cleaned,
                      },
                    },
                  },
                });
              } else {
                showInfoToast("Longitude must be between -180 and 180");
              }
            }}
            
            className="w-full px-4 py-2 bg-slate-100 border border-slate-300 text-gray-700 rounded-md shadow-sm focus:outline-none"
          />
        </div>            </div>
              <div className="flex justify-between gap-2">
                <Label label={"Address"} />
                <div className="flex items-center justify-center w-[75%]">
                  <input
                    type="text"
                    value={formData.contactUs.map.address}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        contactUs: {
                          ...formData.contactUs,
                          map: {
                            ...formData.contactUs.map,
                            address: e.target.value,
                          },
                        },
                      })
                    }
                    maxLength={120}
                    placeholder="Enter Address"
                    className="w-full px-4 py-2 bg-slate-100 border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none"
                  />
                </div>
              </div>
              <div className="flex justify-between gap-2">
                <Label label={"Email"} />
                <div className="flex items-center justify-center w-[75%]">
                  <input
                    type="email"
                    value={formData.contactUs.map.email}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        contactUs: {
                          ...formData.contactUs,
                          map: {
                            ...formData.contactUs.map,
                            email: e.target.value,
                          },
                        },
                      })
                    }
                    placeholder="Enter email"
                    className="w-full px-4 py-2 bg-slate-100 border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none"
                  />
                </div>
              </div>
              <div className="flex justify-between gap-2">
                <Label label={"Ph number"} />
                <div className="flex items-center justify-center w-[75%]">
                  <input
                    type="text"
                    value={formData.contactUs.map.phoneNumber}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        contactUs: {
                          ...formData.contactUs,
                          map: {
                            ...formData.contactUs.map,
                            phoneNumber: e.target.value,
                          },
                        },
                      })
                    }
                    maxLength={10}
                    placeholder="Enter phone number"
                    className="w-full px-4 py-2 bg-slate-100 border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none"
                  />
                </div>
              </div>
            </div>
          </div>
          <Heading text="Customer Testimonial" Icon={MdOutlineSettings} />
          <div className="px-10 pt-6 pb-16">
            <div className="flex flex-col gap-3">
              <div className="flex justify-between gap-2">
                <Label label={"Enable This Section"} />
                <div className="flex w-[75%]">
                  <label className="inline-flex mb-5 cursor-pointer">
                    <input
                      type="checkbox"
                      checked={formData.customerTestimonial.enable}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          customerTestimonial: {
                            ...formData.customerTestimonial,
                            enable: e.target.checked,
                          },
                        })
                      }
                      className="sr-only peer"
                    />
                    <div className="relative w-9 h-5 bg-red-500 rounded-full peer-checked:bg-emerald-600 after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:after:translate-x-full" />
                  </label>
                </div>
              </div>
              <div className="flex justify-between gap-2">
                <Label label={"Section Title"} />
                <div className="flex items-center justify-center w-[75%]">
                  <input
                    type="text"
                    placeholder="Enter section title"
                    value={formData.customerTestimonial.title}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        customerTestimonial: {
                          ...formData.customerTestimonial,
                          title: e.target.value,
                        },
                      })
                    }
                    maxLength={50}
                    className="w-full px-4 py-2 bg-slate-100 border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none"
                  />
                </div>
              </div>
              {["customer1", "customer2", "customer3"].map(
                (customer, index) => (
                  <div key={customer}>
                    <div className="flex justify-between gap-2">
                      <Label label={`Customer ${index + 1}`} />
                      <div className="flex items-center justify-center w-[75%]">
                        <input
                          type="text"
                          placeholder={`Enter customer ${index + 1} name`}
                          value={formData.customerTestimonial[customer].name}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              customerTestimonial: {
                                ...formData.customerTestimonial,
                                [customer]: {
                                  ...formData.customerTestimonial[customer],
                                  name: e.target.value,
                                },
                              },
                            })
                          }
                          maxLength={15}
                          className="w-full px-4 py-2 bg-slate-100 border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none"
                        />
                      </div>
                    </div>
                    <div className="flex justify-between gap-2 mt-4">
                      <Label label={`Customer Testimonial ${index + 1}`} />
                      <div className="flex items-center justify-center w-[75%]">
                        <textarea
                          placeholder={`Enter Customer Testimonial ${
                            index + 1
                          }`}
                          value={
                            formData.customerTestimonial[customer].feedback
                          }
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              customerTestimonial: {
                                ...formData.customerTestimonial,
                                [customer]: {
                                  ...formData.customerTestimonial[customer],
                                  feedback: e.target.value,
                                },
                              },
                            })
                          }
                          maxLength={120}
                          className="w-full px-4 py-2 bg-slate-100 border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none"
                        />
                      </div>
                    </div>
                  </div>
                )
              )}
            </div>
          </div>

          {/* {Video Slider} */}

          <Heading text="Video Section" Icon={MdOutlineSettings} />

          <div className="px-10 pt-6 pb-16">
            <div className="flex flex-col gap-3">
              <div className="flex  justify-between gap-2">
                <Label label={"Enable This Section"} />

                <div class="flex  w-[75%]">
                  <label class="inline-flex  mb-5 cursor-pointer">
                    <input
                      type="checkbox"
                      checked={formData.videoSection.enable}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          videoSection: {
                            ...formData.videoSection,
                            enable: e.target.checked,
                          },
                        })
                      }
                      className="sr-only peer"
                    />
                    <div className="relative w-9 h-5 bg-red-500 rounded-full peer-checked:bg-emerald-600 after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:after:translate-x-full" />
                  </label>
                </div>
              </div>

              <div className="flex  justify-between gap-2 ">
                <Label label={"Section Title"} />

                <div class="flex items-center justify-center w-[75%]">
                  <input
                    type="text"
                    value={formData.videoSection.title}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        videoSection: {
                          ...formData.videoSection,
                          title: e.target.value,
                        },
                      })
                    }
                    maxLength={50}
                    placeholder="Enter Title"
                    class="w-full px-4 py-2 bg-slate-100  border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none "
                  />
                </div>
              </div>

              <div className="flex justify-between gap-2">
                <Label label={"Video Link"} />

                <div className="flex flex-col gap-1 w-[75%] relative">
                  <div className="flex items-center justify-center w-full">
                    <input
                      type="text"
                      value={formData.videoSection.videoLink}
                      onChange={(e) => {
                        const value = e.target.value;
                        const youtubeRegex =
                          /^(https?:\/\/)?(www\.)?(youtube\.com\/watch\?v=|youtu\.be\/).+/;

                        if (value === "" || youtubeRegex.test(value)) {
                          setFormData({
                            ...formData,
                            videoSection: {
                              ...formData.videoSection,
                              videoLink: value,
                            },
                          });
                          setVideoWarning(false);
                        } else {
                          setVideoWarning(true);
                          setTimeout(() => {
                            setVideoWarning(false);
                          }, 2000);
                        }
                      }}
                      placeholder="Paste the YouTube video link"
                      className="w-full px-4 py-2 bg-slate-100 border border-slate-300 text-gray-700 rounded-md shadow-sm focus:outline-none"
                    />
                  </div>

                  {videoWarning && (
                    <div className="absolute top-full left-0 mt-1 bg-red-500 text-white text-xs px-3 py-1 rounded shadow z-10 w-max">
                      Paste the YouTube video link
                    </div>
                  )}
                </div>
              </div>

              <div className="flex  justify-between gap-2 ">
                <Label label={"Section Description"} />

                <div class="flex items-center justify-center w-[75%]">
                  <input
                    type="text"
                    value={formData.videoSection.description}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        videoSection: {
                          ...formData.videoSection,
                          description: e.target.value,
                        },
                      })
                    }
                    maxLength={120}
                    placeholder="Enter Section Description"
                    class="w-full px-4 py-2 bg-slate-100  border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none "
                  />
                </div>
              </div>
            </div>
          </div>

          {/* {footer Slider} */}

          <Heading text="Footer Message" Icon={MdOutlineSettings} />

          <div className="px-10 pt-6 pb-16">
            <div className="flex flex-col gap-3">
              <div className="flex  justify-between gap-2 ">
                <Label label={"Section Description"} />

                <div class="flex items-center justify-center w-[75%]">
                  <input
                    type="text"
                    value={formData.footer.description}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        footer: {
                          ...formData.footer,
                          description: e.target.value,
                        },
                      })
                    }
                    maxLength={50}
                    placeholder="Enter Description"
                    class="w-full px-4 py-2 bg-slate-100  border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none "
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div></div>
      </div>

      {openPopup && (
        <GLpageTemplatePopup
          ClosePopup={handleClosePopup}
          GLPageId={GLPageId}
          initialPropertyType={formData.propertyType || "Villa"}
          initialPropertyTypeValue={formData.propertyTypeName || "1"}
          initialProperty={formData.propertyName}
          initialStyle={formData.pageStyle}
          initialPropertyId={formData.propertyId}
        />
      )}
    </div>
  );
};

export default GLpageCreatingSection;
